import { FilterOption } from '../components/custom-input/FilterDropdown';
import { MARKETPLACE_PROFILE_CONSTANTS } from './common';

export const COUNTRY_CODES = [{ name: 'United States', value: 'US' }];

export const COUNTRIES_WITH_STATES: { [key: string]: FilterOption<string>[] } = {
  US: [
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'Delaware', value: 'DE' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Illinois', value: 'IL' },
    { name: 'Indiana', value: 'IN' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' },
  ],
};

export const METHOD_OPTIONS: FilterOption<string>[] = [
  { name: 'Conventional', value: 'Conventional' },
  { name: 'IVF', value: 'IVF' },
];

export const MARKETPLACE_BREED_OPTIONS: FilterOption<string>[] = [
  { name: 'All Breeds', value: '' },
  { name: 'Angus', value: 'Angus' },
  { name: 'Hereford', value: 'Hereford' },
];

export const MARKETPLACE_PRODUCT_TYPE_OPTIONS: FilterOption<string>[] = [
  { name: 'All Types', value: '' },
  { name: 'Semen', value: 'Semen' },
  { name: 'Embryo', value: 'Embryo' },
];

export const MARKETPLACE_SELLER_OPTIONS: FilterOption<string>[] = [
  { name: 'All Sellers', value: '' },
  { name: 'GreenGrass Farm', value: 'GreenGrass Farm' },
];

export const MARKETPLACE_STATUS_OPTIONS: FilterOption<string>[] = [
  { name: 'Active', value: 'Active' },
  { name: 'Inactive', value: 'Inactive' },
  { name: 'All', value: '' },
];

export const COMMISSION_REPORT_DATE_RANGE_OPTIONS: FilterOption<string>[] = [
  { name: 'Last 7 Days', value: '7' },
  { name: 'Last 30 Days', value: '30' },
  { name: 'Last 3 Months', value: '90' },
  { name: 'Last 6 Months', value: '180' },
  { name: 'Last 12 Months', value: '365' },
];

export const COMMISSION_REPORT_ORDER_STATUS_OPTIONS: FilterOption<string>[] = [
  { name: 'All', value: '' },
  { name: 'Complete', value: 'Complete' },
  { name: 'Pending', value: 'Pending' },
];

export const BREEDER_PAYMENTS_MONTH_OPTIONS: FilterOption<string>[] = (() => {
  const options: FilterOption<string>[] = [{ name: 'All Months', value: '' }];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = d.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    options.push({ name: label, value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}` });
  }
  return options;
})();

export const BREEDER_PAYMENTS_STATUS_OPTIONS: FilterOption<string>[] = [
  { name: 'All Status', value: '' },
  { name: 'Scheduled', value: 'Scheduled' },
  { name: 'Paid', value: 'Paid' },
  { name: 'Pending', value: 'Pending' },
  { name: 'Cancelled', value: 'Cancelled' },
];

export const SOCIAL_FIELD_LABELS = {
  websiteUrl: 'Website',
  instagramUrl: 'Instagram',
  facebookUrl: 'Facebook',
  youTubeUrl: 'YouTube',
};

export const SOCIAL_ICON_CONFIG = [
  { key: 'websiteUrl', src: '/images/web-colored.png', alt: MARKETPLACE_PROFILE_CONSTANTS.ALT_WEBSITE },
  { key: 'instagramUrl', src: '/images/instagram-colored.png', alt: MARKETPLACE_PROFILE_CONSTANTS.ALT_INSTAGRAM },
  { key: 'facebookUrl', src: '/images/facebook-colored.png', alt: MARKETPLACE_PROFILE_CONSTANTS.ALT_FACEBOOK },
  { key: 'youTubeUrl', src: '/images/youtube-colored.png', alt: MARKETPLACE_PROFILE_CONSTANTS.ALT_YOUTUBE },
];
